import { Vector3 } from 'three';

export const STANDARD_GRAVITY: Vector3 = new Vector3(0, -9.81, 0);
